app.factory("Position", ["$http",
    function ($http) {
        var Position = {};
        var baseUrl = '/positions';


        Position.list = function (params) {
            params = params || {};
            return $http.get(baseUrl + "/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    organization: params.organization,
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Position.create = function (params) {
            return $http.post(baseUrl + "/create", {
                name: params.name,
                description: params.description,
                organization: params.organization,
                isRoot: params.isRoot
            }).then(function () {
                return true;
            });
        };

        Position.edit = function (params) {
            return $http.post(baseUrl + "/edit", {
                _id: params._id,
                name: params.name,
                description: params.description,
                isRoot: params.isRoot,
                organization: params.organization
            }).then(function (res) {
                return true;
            });
        };

        Position.remove = function (params) {
            return $http.post(baseUrl + "/remove", {
                positionId: params.positionId
            }).then(function (resp) {
                return resp.data;
            });
        };

        Position.fetchOne = function (PositionId) {
            return $http.get(baseUrl + "/" + PositionId).then(function (resp) {
                return resp.data;
            });
        };

        Position.findByQuery = function (query) {
            return $http.post(baseUrl + "/search",
                query
            ).then(function (resp) {
                return resp.data
            })
        };

        Position.AssignRole = function (params) {
            return $http.post(baseUrl + "/role/add", {
                positionId: params.positionId,
                roleId: params.roleId
            }).then(function (resp) {
                return resp.data;
            });
        };

        Position.RevokeRole = function (params) {
            return $http.post(baseUrl + "/role/remove", {
                positionId: params.positionId,
                roleId: params.roleId
            }).then(function (resp) {
                return resp.data;
            });
        };

        return Position;
    }
]);
